module.exports = __webpack_public_path__ + "prod/1.42.2/img/serve-four.de2e9ad8.png";